import { createSelector } from 'reselect';
import { Selector } from '../rootReducer';

import * as experimentsSelectors from '../experiments/selectors';
import * as videoInfoSelectors from '../videoInfo/selectors';
import { Theme } from './constants';
import { getThemeStyle } from './themeStyles';
import { IVideoMusic, IVideoStyle } from './types';

const _getVideoThemeId: Selector<string> = (state) => state.videoStyle.themeId;
const _getVideoStyle: Selector<IVideoStyle> = (state) => state.videoStyle.style;
const _getVideoMusic: Selector<IVideoMusic> = (state) => state.videoStyle.music;

// NOTE: video theme or default
const getVideoThemeId: Selector<string> = createSelector(
  _getVideoThemeId,
  videoInfoSelectors.isBusinessFlow,
  (themeId, isBusiness) => themeId || (isBusiness ? Theme.MINIMAL : Theme.EDGY),
);

// NOTE: video theme style or default
const getVideoStyle: Selector<IVideoStyle> = createSelector(
  _getVideoStyle,
  getVideoThemeId,
  (style, themeId) => style || getThemeStyle(themeId),
);

const getSelectedFont: Selector<string> = createSelector(
  getVideoStyle,
  (videoStyle) => videoStyle.activeFont,
);

const getPrimaryColor: Selector<string> = createSelector(
  getVideoStyle,
  (videoStyle) => videoStyle.primaryColor,
);

const getSecondaryColor: Selector<string> = createSelector(
  getVideoStyle,
  (videoStyle) => videoStyle.secondaryColor,
);

const getMusicTag: Selector<string> = createSelector(
  _getVideoMusic,
  (music) => music.tag,
);

const getMusicTrackId: Selector<string> = createSelector(
  _getVideoMusic,
  (music) => music.trackId,
);

const isShortFlowEnabled: Selector<boolean> =
  experimentsSelectors.isShortFlowEnabled;

const isShortFlowActive: Selector<boolean> = (state) =>
  isShortFlowEnabled(state) && !state.videoStyle.isShortFlowInactive;

export {
  getVideoThemeId,
  getVideoStyle,
  getPrimaryColor,
  getSecondaryColor,
  getSelectedFont,
  getMusicTag,
  getMusicTrackId,
  isShortFlowEnabled,
  isShortFlowActive,
};
